import type { IWidgetModelTypesType } from "app/components/widget/widget-types/Widget";
import { useCallback, useState } from "react";
import type { IServices } from "app/pages/industry-analysis/overview/components/IndustryOverviewContext/IndustryOverviewContext";
import { AddToDashboardButton } from "app/components/React/AddToDashboard/AddToDashboardButton";
import { AddToDashboardModalV2 } from "pro-features/components/Modals/src/AddToDashboardModal-v2";
import { useCurrentStateAndParams } from "@uirouter/react";

interface IIndustryOverviewAddToDashboardProps {
    metric: string;
    type: IWidgetModelTypesType;
    services: IServices;
    overrideParams?: Record<string, string | number>;
}

export const IndustryOverviewAddToDashboard: React.FunctionComponent<IIndustryOverviewAddToDashboardProps> = (
    props,
) => {
    const { metric, type, services, overrideParams = {} } = props;
    const [isOpen, setIsOpen] = useState(false);
    const { params } = useCurrentStateAndParams();
    const getCustomModel = () => {
        const apiParams = { ...params, ...overrideParams };
        const { category: categoryParam, webSource, country, duration, comparedDuration } = apiParams;

        const category = services.categoryService.categoryQueryParamToCategoryObject(categoryParam[0]);
        const { id, isCustomCategory, name, text, categoryId } = category;

        const key = isCustomCategory
            ? { id: categoryId, name, category: categoryId }
            : {
                  id: `$${id}`,
                  name: text,
                  category: `$${id}`,
              };

        return {
            type: type,
            metric: metric,
            webSource: webSource,
            country: country,
            duration: duration,
            comparedDuration: comparedDuration,
            family: "Industry",
            customAsset: "Industry",
            key: [key],
        };
    };

    const onConfirm = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);

    const handleOpen = useCallback(() => {
        setIsOpen(true);
    }, [setIsOpen]);

    return (
        <>
            <AddToDashboardButton onClick={handleOpen} />
            {isOpen && (
                <AddToDashboardModalV2
                    customModel={getCustomModel() as any}
                    onConfirm={onConfirm}
                    onCancel={handleClose}
                />
            )}
        </>
    );
};
